import { render, staticRenderFns } from "./BookingLossCalculatorCom.vue?vue&type=template&id=4d4070af&scoped=true"
import script from "./BookingLossCalculatorCom.vue?vue&type=script&lang=js"
export * from "./BookingLossCalculatorCom.vue?vue&type=script&lang=js"
import style0 from "./BookingLossCalculatorCom.vue?vue&type=style&index=0&id=4d4070af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4070af",
  null
  
)

export default component.exports